// SSP reducer to handle alert dismissal logic
import type { TSSPChain } from '@belong/ssp-execution';
import { IPageAlert } from '@belong/types/alert';
import { hasAlertBeenDismissed } from '@belong/ui-components/components/feedback/Alert/Alert.cookies';
import { TPublicSSPContext } from './types';

export const alertDismissalEnrichment = (alertDismissalCtx: TPublicSSPContext): IPageAlert | undefined => {
  const { alert } = alertDismissalCtx.pageProps;

  if (!alert) {
    return undefined;
  }

  return {
    ...alert,
    dismissed: alert.dismissedCookieId
      ? hasAlertBeenDismissed(alert.dismissedCookieId, false, alertDismissalCtx.context)
      : false
  };
};

export const alertDismissalSSP: TSSPChain<TPublicSSPContext> = async ctx => {
  return {
    ...ctx,
    alert: alertDismissalEnrichment(ctx)
  };
};
